export class Help {
    HelpId: number;
    PageName: string;
    ParentId: number;
    HelpText: string;
    IsActive: boolean;
    ModifiedBy: number;
    ModifiedOn: Date;
}